// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database';
import { ref, set, onValue, remove, push } from 'firebase/database';
import { getAuth, onAuthStateChanged, signInAnonymously } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: 'AIzaSyBabwrhhTk18F8ji2Tu_6nUqnpEUd_IgmM',
    authDomain: 'xrpdf-3e5d1.firebaseapp.com',
    projectId: 'xrpdf-3e5d1',
    storageBucket: 'xrpdf-3e5d1.appspot.com',
    messagingSenderId: '958178012131',
    appId: '1:958178012131:web:23ca70f84feef3e7910ed6',
    databaseURL: 'https://xrpdf-3e5d1-default-rtdb.firebaseio.com',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const database = getDatabase(app);
export { app, storage, database };



export const dbRef    = (path) => ref(database, path);
export const dbWrite = (path, value) =>
  set(ref(database, path), value).catch(err => console.error('dbWrite', path, err));
export const dbOn     = (path, cb) => onValue(ref(database, path), s => cb(s.val()));
export const dbRemove = (path) => remove(ref(database, path));
export const dbPush = (path, value) => {
  const keyRef = push(ref(database, path));
  return set(keyRef, value).catch(err => console.error('dbPush', path, err));
};

export async function ensureAuth() {
  const auth = getAuth();
  if (auth.currentUser) return auth.currentUser;
  return new Promise((resolve, reject) => {
    onAuthStateChanged(auth, async (user) => {
      if (user) return resolve(user);
      try {
        const cred = await signInAnonymously(auth);
        resolve(cred.user);
      } catch (e) {
        console.error('[ensureAuth] anon sign-in failed', e);
        reject(e);
      }
    });
  });
}